// Modal handler functions for the Job Schedule Table

// EditJobModal handlers
export const createEditJobHandlers = (setSelectedJob, setShowModal, hasEditAccess) => {
  const handleOpenModal = (e, job) => {
    if (!hasEditAccess) return; // Prevent editing if user doesn't have permission
    e.stopPropagation(); // Prevent row click event
    setSelectedJob(job);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedJob(null);
  };

  const handleSaveChanges = () => {
    // The changes are saved in the EditJobModal component
    console.log("Job updated successfully");
  };

  return { handleOpenModal, handleCloseModal, handleSaveChanges };
};

// NewJobModal handlers
export const createNewJobHandlers = (setShowNewJobModal, setMoJobData, hasEditAccess) => {
  const handleOpenNewJobModal = () => {
    if (!hasEditAccess) return; // Prevent creating new jobs if user doesn't have permission
    setShowNewJobModal(true);
  };

  const handleCloseNewJobModal = () => {
    setShowNewJobModal(false);
    // Reset the MO job data when the modal is closed to prevent data persistence
    setMoJobData(null);
  };

  return { handleOpenNewJobModal, handleCloseNewJobModal };
};

// MOSearchModal handlers
export const createMOSearchHandlers = (setShowMOSearchModal, setMoJobData, setShowNewJobModal, hasEditAccess) => {
  const handleOpenMOSearchModal = () => {
    if (!hasEditAccess) return; // Prevent adding MOs if user doesn't have permission
    setShowMOSearchModal(true);
  };

  const handleCloseMOSearchModal = () => {
    setShowMOSearchModal(false);
  };

  const handleSelectMO = (moData) => {
    if (!hasEditAccess) return; // Prevent adding MOs if user doesn't have permission
    setMoJobData(moData);
    setShowMOSearchModal(false);
    setShowNewJobModal(true);
  };

  return { handleOpenMOSearchModal, handleCloseMOSearchModal, handleSelectMO };
};

// Excel Export Modal handlers
export const createExcelExportHandlers = (setShowExcelExportModal) => {
  const handleExportButtonClick = () => {
    setShowExcelExportModal(true);
  };

  return { handleExportButtonClick };
};

// Generic modal close handler with confirmation dialog
export const createModalCloseHandler = (handleCloseModal) => {
  return () => {
    // Get reference to the modal component
    const modalComponent = document.querySelector(".modal-content")
      .closest(".modal");
    
    // Dispatch a click event on the modal's internal close handler
    // which will trigger the confirmation dialog if needed
    const closeButton = modalComponent?.querySelector(".modal-header .btn-close");
    if (closeButton) {
      closeButton.click();
    } else {
      // Fallback if button not found
      handleCloseModal();
    }
  };
};
